import React from 'react'

const Debug = (props) => {
    return (
        <div className="page-content header-clear-medium">
        <div className="card card-style contact-form">
          <div className="content">
        <table className="table">
            <tbody>
            <tr>
                 <td>Tracelength</td>
                 <td>{props.uservariables['Tracelength']}</td>                 
             </tr>  
            {Object.keys(props.uservariables).map((uservariable)=>(
                 <tr>
                 <td>{uservariable}</td>
                 <td>{props.uservariables[uservariable]}</td>
                 
             </tr>                
            ))}

            </tbody>
        </table>
       </div>
       </div> 
       </div>
    )
}

export default Debug
